import React from 'react';

import SVGIcon, { GENERAL_ICONS } from 'src/components/svg';

const Logo = React.memo(({ logoProps, titleProps, screenDetail = {} }) => (
  <div className={'mc-logo'}>
    <SVGIcon
      iconname={GENERAL_ICONS.LOGO}
      {...(screenDetail.isSmallScreen ? { width: 50, height: 50 } : {})}
      {...logoProps}
    />
    <div className={'mc-logo-title'} {...titleProps}>
      <span className={'mc-logo-title-left'}>Life</span>
      <span className={'mc-logo-title-right'}>App</span>
    </div>
  </div>
));
Logo.displayName = 'Logo';

export default Logo;
